import { Component, Injector, Input, OnInit } from '@angular/core';
import * as toastr from 'toastr';
import { ConfirmationService } from 'primeng/api';
import { ContratoStorageService } from 'compra-lib';
import { FuncaoService } from '../../../util/funcao.service';
import { ProgressoService } from '../../../components/progresso/service/progresso.service';
import { PNCPService } from '../../../util/pncp.service';
import { PncpContratoService } from '../../service/contrato.service';
import { Contrato } from '../../../entidade/compra/contrato.model';
import { Login } from '../../../entidade/login/login';
import { ContratoStorage } from '../../../entidade/compra/contrato-storage.model';
import { ContratoEnvolvidos } from 'eddydata-lib';
import { ContratoEnvolvidosService } from 'projects/compra-lib/src/lib/contrato/service/contrato-envolvido.service';

declare var $: any;

@Component({
  selector: 'app-pncp-atas-cadastro',
  templateUrl: './pncp-atas-cadastro.component.html',
  styleUrls: ['./pncp-atas-cadastro.component.css']
})
export class PncpAtasCadastroComponent implements OnInit {

  @Input() login: Login;
  @Input() contrato: Contrato;



  historicoCompra: Array<any> = new Array<any>();
  public justificativa: string;
  public justificativaEntidade: string
  public justificativaExclusaoAta: string
  public itemAtual: any;
  resultados: Array<{ item: string, sucesso: boolean, mensagem: string }> = new Array<{ item: string, sucesso: boolean, mensagem: string }>();
  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    protected contratoService: PncpContratoService,
    protected confirmationService: ConfirmationService,
    protected pncpService: PNCPService,
    protected progressoService: ProgressoService,
    private funcaoService: FuncaoService,
    private contratoEnvolvidosService: ContratoEnvolvidosService,
    private storage: ContratoStorageService) {
  }

  ngOnInit(): void {
  }


  abrirPncp(tipo: 'A' | 'L') {
    const ano = (tipo == 'L' ? this.contrato.licitacao.exercicio.ano : new Date(this.contrato.data_assinatura).getFullYear());
    const sequencial = (tipo == 'L' ? this.contrato.licitacao.sequencial_pncp : `${this.contrato.licitacao.sequencial_pncp}/${this.contrato.sequencial_pncp}`);

    window.open(this.pncpService.abrirPortalPNCP(this.contrato.orgao.cnpj, ano, `/${sequencial}`, tipo == 'L' ? 'E' : 'A'), '_blank');
  }

  idPncp(tipo: 'L' | 'A'): string {
    if (tipo == 'L') {
      return `${this.login.orgao.cnpj.replace(/\D/g, '')}-1-${("000000" + this.contrato.licitacao.sequencial_pncp).slice((this.contrato.licitacao.sequencial_pncp + '').length)}/${this.contrato.licitacao.exercicio.ano}`;
    } else {
      return `${this.login.orgao.cnpj.replace(/\D/g, '')}-1-${("000000" + this.contrato.sequencial_pncp).slice((this.contrato.sequencial_pncp + '').length)}/${this.contrato.ano}`;
    }
  }

  cancelarAta() {
    this.confirmationService.confirm({
      header: 'Cancelar ata',
      message: `<pre>Confirma o cancelamento dessa ata? Essa ação NÃO poderá ser desfeita.</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo cancelamento.',
      rejectLabel: 'Não',
      accept: async () => {
        this.pncpService.enviarAtaRegistroPreco([this.contrato.id], true).subscribe((idTransacao) => {
          this.progressoService.show(idTransacao, async (retorno) => {
            this.resultados = retorno;
          });
        }, e => {
          this.funcaoService.acaoErro(e);
        });
      }
    });
  }

  apagarAta() {
    this.confirmationService.confirm({
      header: 'Cancelar ata',
      message: `<pre>Confirma a exclusão dessa ata? Essa ação NÃO pode ser desfeita.</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        this.justificativaExclusaoAta = '';
        this.itemAtual = this.contrato
        $('#dialogJustificativaAta').modal('show');
      }
    });
  }

  enviarArquivo(item: ContratoStorage) {
    this.confirmationService.confirm({
      header: 'Envio de documento',
      message: `<pre>Confirma o envio do arquivo?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo envio.',
      rejectLabel: 'Não',
      accept: async () => {
        const aux = Object.assign({}, this.contrato);
        aux.arquivos = [];
        item.contrato = aux;
        this.pncpService.enviarArquivoAta(item).subscribe((idTransacao) => {
          this.progressoService.show(idTransacao, async (retorno) => {
            this.resultados = retorno;
            if (this.resultados[0].sucesso) {
              const index = this.contrato.arquivos.indexOf(item);
              item.sequencial_pncp = +this.resultados[0].mensagem.split(':')[1];
              this.contrato.arquivos[index] = item;
            }
          });
        }, e => {
          this.funcaoService.acaoErro(e);
        });
      }
    });
  }

  enviarEntidade(item: ContratoEnvolvidos) {
    this.confirmationService.confirm({
      header: 'Envio de orgãos/entidades',
      message: `<pre>Confirma o envio de orgão/entidades?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo envio.',
      rejectLabel: 'Não',
      accept: async () => {
        const aux = Object.assign({}, this.contrato);
        aux.arquivos = [];
        item.contrato = aux;
        this.pncpService.enviarParteEnvolvida(this.contrato, item).subscribe(async (res) => {
          const index = this.contrato.contrato_envolvidos.indexOf(item);
          this.contrato.contrato_envolvidos[index].cadastrado_pncp = true;
          await this.contratoEnvolvidosService.atualizarEnvolvidosPncp(item.id, true).toPromise();
          toastr.success('Parte envolvida enviada com sucesso do PNCP')
        }, e => {
          toastr.error(e.error.message);
        });
      }
    });
  }

  apagarEntidade(item: ContratoEnvolvidos) {
    this.confirmationService.confirm({
      header: 'Apagar orgãos/entidades',
      message: `<pre>Confirma a remoção de orgão/entidade?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        const aux = Object.assign({}, this.contrato);
        aux.arquivos = [];
        item.contrato = aux;
        this.justificativaEntidade = '';
        this.itemAtual = item;
        $('#dialogJustificativaEntidade').modal('show');
      }
    });
  }

  apagarArquivo(item: ContratoStorage) {
    this.confirmationService.confirm({
      header: 'Apagar documento',
      message: `<pre>Confirma a remoção do documento?</pre>.`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim, confirmo exclusão.',
      rejectLabel: 'Não',
      accept: async () => {
        const aux = Object.assign({}, this.contrato);
        aux.arquivos = [];
        item.contrato = aux;
        this.justificativa = '';
        console.log(item)
        this.itemAtual = item;
        $('#dialogJustificativa').modal('show');
      }
    });
  }

  public confirmarExclusaoEntidade() {
    if (!this.justificativaEntidade || this.justificativaEntidade == '') {
      toastr.warning(`Informe a justificativa para exclusão do orgão/entidade.`)
      return
    }
    if (this.justificativaEntidade.length > 255) {
      toastr.warning(`A justificativa deve ter no maximo 255 caracteres.`)
      return
    }

    this.pncpService.apagarParteEnvolvida(this.contrato, this.itemAtual, this.contrato.ano, this.justificativaEntidade).subscribe(async (res) => {
      const index = this.contrato.contrato_envolvidos.indexOf(this.itemAtual);
      this.itemAtual.cadastrado_pncp = false;
      await this.contratoEnvolvidosService.atualizarEnvolvidosPncp(this.itemAtual.id, false).toPromise();
      this.contrato.contrato_envolvidos[index] = this.itemAtual;
      toastr.success('Orgão/Entidade removido com sucesso do pncp!');
      $('#dialogJustificativaEntidade').modal('hide');
    }, e => {
      if (e.error?.message) {
        toastr.error(e.error.message);
      } else {
        this.funcaoService.acaoErro(e);
      }
    });
  }

  async buscarHistoricoAta() {
    this.historicoCompra = await this.pncpService.consultarHistoricoAta(this.login.orgao.cnpj.replace(/[./-]/g, ''), this.contrato.ano, this.contrato.licitacao.sequencial_pncp, this.contrato.sequencial_pncp).toPromise();
  }


  public confirmarExclusao() {
    if (!this.justificativa || this.justificativa == '') {
      toastr.warning(`Informe a justificativa para exclusão do arquivo.`)
      return
    }
    if (this.justificativa.length > 255) {
      toastr.warning(`A justificativa deve ter no maximo 255 caracteres.`)
      return
    }

    this.pncpService.apagarArquivoAta(this.itemAtual, this.justificativa).subscribe(async (res) => {
      const index = this.contrato.arquivos.indexOf(this.itemAtual);
      const seq = this.itemAtual.sequencial_pncp;
      this.itemAtual.sequencial_pncp = null;
      await this.storage.atualizar(this.itemAtual).toPromise();
      this.contrato.arquivos[index] = this.itemAtual;
      toastr.success('Arquivo removido com sucesso do pncp!');
      $('#dialogJustificativa').modal('hide');
    }, e => {
      if (e.error?.message) {
        toastr.error(e.error.message);
      } else {
        this.funcaoService.acaoErro(e);
      }
    });
  }

  public confirmarExclusaoAta() {
    if (!this.justificativaExclusaoAta || this.justificativaExclusaoAta == '') {
      toastr.warning(`Informe a justificativa para exclusão do arquivo.`)
      return
    }
    if (this.justificativaExclusaoAta.length > 255) {
      toastr.warning(`A justificativa deve ter no maximo 255 caracteres.`)
      return
    }

    this.pncpService.excluirAtaRegistroPreco(this.itemAtual, this.justificativaExclusaoAta).subscribe(async (res) => {
      this.itemAtual.cadastrado_pncp = false;
      await this.contratoService.atualizarContratoPncp(this.itemAtual.id, false).toPromise();
      this.contrato = null;
      this.justificativaExclusaoAta = '';
      toastr.success('Ata removido com sucesso do pncp!');
      $('#dialogJustificativaAta').modal('hide');
      window.location.reload();
    }, e => {
      if (e.error?.message) {
        toastr.error(e.error.message);
      } else {
        this.funcaoService.acaoErro(e);
      }
    });
  }

}
